import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuCircleAlert, LuClock, LuLock, LuX } from 'react-icons/lu';
import API from '../../api/axios';
import './Abonnement.css';

/**
 * Bandeau d'alerte d'abonnement affiché en haut de toutes les pages
 * (propriétaire, gérant, serveur, caissier) :
 * échéance proche (≤ 7 jours), période de grâce, lecture seule, suspension.
 */
export default function AbonnementBandeau({ role }) {
  const [etat, setEtat] = useState(null);
  const [masque, setMasque] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (role === 'admin') return undefined;
    let actif = true;
    const charger = () => API.get('/abonnements/etat')
      .then(r => { if (actif) setEtat(r.data); })
      .catch(() => {});
    charger();
    const t = setInterval(charger, 5 * 60 * 1000);
    return () => { actif = false; clearInterval(t); };
  }, [role]);

  if (!etat || role === 'admin') return null;

  // Établissement le plus urgent
  const ordre = { lecture_seule: 0, suspendu: 1, grace: 2, expire_bientot: 3 };
  const urgents = (etat.etablissements || [])
    .filter(e => e.etat in ordre)
    .sort((a, b) => ordre[a.etat] - ordre[b.etat] || (a.jours_restants ?? 0) - (b.jours_restants ?? 0));
  if (!urgents.length) return null;
  const e = urgents[0];
  const bloquant = e.etat === 'lecture_seule' || e.etat === 'suspendu';
  if (masque && !bloquant) return null;

  const plusieurs = role === 'proprietaire' && urgents.length > 1 ? ` (+${urgents.length - 1} autre${urgents.length > 2 ? 's' : ''})` : '';
  const nom = role === 'proprietaire' ? `${e.etablissement_nom} : ` : '';
  let texte; let Icone; let ton;
  if (e.etat === 'lecture_seule') {
    texte = `${nom}abonnement expiré, StockPro est en lecture seule (ventes et stock bloqués).`;
    Icone = LuLock; ton = 'danger';
  } else if (e.etat === 'suspendu') {
    texte = `${nom}abonnement suspendu, StockPro est en lecture seule.`;
    Icone = LuLock; ton = 'danger';
  } else if (e.etat === 'grace') {
    texte = `${nom}abonnement expiré. Lecture seule dans ${e.jours_grace_restants} jour${e.jours_grace_restants > 1 ? 's' : ''} sans paiement.`;
    Icone = LuCircleAlert; ton = 'danger';
  } else {
    texte = `${nom}l'abonnement expire ${e.jours_restants <= 0 ? "aujourd'hui" : `dans ${e.jours_restants} jour${e.jours_restants > 1 ? 's' : ''}`}.`;
    Icone = LuClock; ton = 'alerte';
  }

  return (
    <div className={`ab-bandeau is-${ton}`} role="alert">
      <Icone aria-hidden className="ab-bandeau-icone" />
      <span className="ab-bandeau-texte">{texte.charAt(0).toUpperCase() + texte.slice(1)}{plusieurs}</span>
      {role === 'proprietaire'
        ? <button className="ab-bandeau-btn" onClick={() => navigate('/proprietaire/abonnement')}>Renouveler</button>
        : <span className="ab-bandeau-note">Contactez le propriétaire.</span>}
      {!bloquant && (
        <button className="ab-bandeau-fermer" aria-label="Masquer" onClick={() => setMasque(true)}><LuX aria-hidden /></button>
      )}
    </div>
  );
}
